// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3Qjvo","name":"ConsentHeader_name__1MZrB","birthday":"ConsentHeader_birthday__fHSl3","skeleton":"ConsentHeader_skeleton__1G0Mn"};